import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ExpandableRow from '../../../components/ExpandableRow/ExpandableRow';
import { formatDate } from '../../../utils/DateUtils';
import { useTranslation } from 'react-i18next';

const ViewRoleDialog = ({ open, onClose, role, permissions = [], rolesPermissions }) => {
  
  const { t } = useTranslation();
  const rolePermissions = rolesPermissions[role.id] || [];

  const getSelectedCountForCategory = (categoryPermissions) => {
    return categoryPermissions.filter(permission => rolePermissions.includes(permission.id)).length;
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="view-role-dialog-title" aria-describedby="view-role-dialog-description">
      <DialogTitle id="view-role-dialog-title">{t('rol_details')}</DialogTitle>
      <DialogContent className='permission-dialog'>
        <DialogContentText id="view-role-dialog-description" className='content-dialog'>
          <span className="roboto-medium">{t('name')}:</span><span className="roboto-light"> {role.name}</span><br/>
          <span className="roboto-medium">{t('description')}:</span><span className="roboto-light"> {role.description}</span><br/>
          <span className="roboto-medium">{t('users_using_the_role')}:</span><span className="roboto-light"> {role.userCount}</span><br/>
          <span className="roboto-medium">{t('created_at')}:</span><span className="roboto-light"> {formatDate(role.createdAt)}</span><br/>
        </DialogContentText>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 450 }} aria-label="permissions table">
            <TableHead>
              <TableRow className='permission-cell-compat'>
                <TableCell><span className="roboto-medium">{t('permission')}</span></TableCell>
                <TableCell align="right"><span className="roboto-medium">{t('enabled')}</span></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {permissions.length > 0 ? (
                permissions.map(({ category, permissions }) => (
                  <ExpandableRow
                    key={category}
                    category={category}
                    permissions={permissions}
                    rolePermissions={rolePermissions}
                    selectedCount={getSelectedCountForCategory(permissions)}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center">{t('empty_permission')}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewRoleDialog;